import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './index.scss';

interface Article {
  id: string;
  title: string;
  description: string;
  date: string;
  category: string;
  image: string;
}

const ArticleList: React.FC = () => {
  const articles: Article[] = [
    {
      id: '1',
      title: 'React 19 新特性详解',
      description: '探索 React 19 的最新特性，包括 Server Components、Actions 和更多激动人心的功能。',
      date: '2026-03-10',
      category: '前端开发',
      image: 'https://picsum.photos/seed/react/800/450'
    },
    {
      id: '2',
      title: 'TypeScript 5.0 实用技巧',
      description: '掌握 TypeScript 5.0 的高级特性，提升代码质量和开发效率。',
      date: '2026-03-05',
      category: '前端开发',
      image: 'https://picsum.photos/seed/typescript/800/450'
    },
    {
      id: '3',
      title: '现代 CSS 布局技术',
      description: '深入了解 Grid、Flexbox 和最新的 CSS 布局技术，创建响应式设计。',
      date: '2026-02-28',
      category: '前端开发',
      image: 'https://picsum.photos/seed/css/800/450'
    },
    {
      id: '4',
      title: 'Web 性能优化指南',
      description: '学习如何优化网站性能，提升用户体验和搜索引擎排名。',
      date: '2026-02-20',
      category: '性能优化',
      image: 'https://picsum.photos/seed/performance/800/450'
    },
    {
      id: '5',
      title: 'Node.js 最新特性',
      description: '探索 Node.js 的最新版本和特性，构建高性能后端应用。',
      date: '2026-02-15',
      category: '后端开发',
      image: 'https://picsum.photos/seed/nodejs/800/450'
    },
    {
      id: '6',
      title: 'AI 在前端开发中的应用',
      description: '了解人工智能如何改变前端开发，以及如何使用 AI 工具提升开发效率。',
      date: '2026-02-10',
      category: '人工智能',
      image: 'https://picsum.photos/seed/ai/800/450'
    }
  ];

  return (
    <section className="article-section">
      <div className="container">
        <div className="section-header">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            最新文章
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            探索技术世界的最新动态和深度见解
          </motion.p>
        </div>

        <div className="article-grid">
          {articles.map((article, index) => (
            <motion.div
              key={article.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10, boxShadow: '0 20px 40px rgba(66, 153, 225, 0.2)' }}
              className="article-card"
            >
              <div className="article-image">
                <img src={article.image} alt={article.title} />
                <div className="article-category">{article.category}</div>
              </div>
              <div className="article-content">
                <h3 className="article-title">
                  <Link to={`/article/${article.id}`}>{article.title}</Link>
                </h3>
                <p className="article-description">{article.description}</p>
                <div className="article-meta">
                  <span className="article-date">{article.date}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="view-more"
        >
          <Link to="/articles" className="btn-view-more">
            查看更多文章
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ArticleList;